import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/bookings")({
  head: () => ({ meta: [{ title: "Orders | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-bookings")),
});
